import { ChangeDetectionStrategy, Component, computed, EventEmitter, Output } from '@angular/core';
import { LL } from 'i18n/i18n.service';
import { RestTimerService } from 'services/rest-timer.service';
import { formatRestDuration } from '@cf-shared/data-model/rest-timer';

@Component({
  selector: 'cs-rest-timer-pill',
  templateUrl: 'cs-rest-timer-pill.html',
  styleUrls: ['cs-rest-timer-pill.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CsRestTimerPillComponent {
  @Output() expand = new EventEmitter<void>();
  protected readonly LL = LL;

  readonly isRunning = this.restTimer.isRunning;
  readonly exerciseName = this.restTimer.exerciseName;
  readonly isExpired = this.restTimer.isExpired;
  // while expired, show the localized "Done!" label instead of 0:00
  readonly timeLabel = computed(() => {
    if (this.restTimer.isExpired()) return LL.workouts.restTimer.done();
    const s = this.restTimer.remainingSeconds();
    return s == null ? '' : formatRestDuration(s);
  });
  // platform gate: native, or web with the test-mode debug flag set
  get isAllowed(): boolean {
    return this.restTimer.isAllowedOnThisPlatform();
  }

  constructor(private readonly restTimer: RestTimerService) {}

  // user tapped the pill: expand to the full-screen overlay
  onTap(): void {
    this.expand.emit();
  }

  // keyboard activation (Enter / Space) for a11y since role=button + tabindex
  // advertise keyboard support
  onKeyDown(ev: KeyboardEvent): void {
    if (ev.key === 'Enter' || ev.key === ' ') {
      ev.preventDefault();
      this.expand.emit();
    }
  }
}
